import React, { useEffect, useState } from 'react';
import { FormHelperText, Box, TextField, Button } from "@material-ui/core";
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { hacerFoco } from '../../../Helpers/utilidades-globales';

export const Pastores = ({ objetoModificacion, validacion, validar }) => {
    const [pastores, setPastores] = useState(objetoModificacion?.obj?.pastores || []);
    const [agregarNombre, setAgregarNombre] = useState(false);

    useEffect(() => {
        objetoModificacion.set({ ...objetoModificacion.obj, pastores: pastores });
    }, [pastores]);

    const addPastor = (value) => {
        setPastores([...pastores, value]);
    };

    const deletePastor = (index) => {
        setPastores(pastores.filter((_, indice) => indice !== index));
    };

    const agregarPastor = () => {
        setAgregarNombre(true);
        setTimeout(() => { hacerFoco('input-pastor-t'); }, 200);
    };

    const checkvalidacion = (campo, validacion) => {
        if (!validar) return '';
        const objetoValidacion = validacion(validar);
        const campos = objetoValidacion[2];
        if (objetoValidacion[0] === true || !Array.isArray(campos)) return '';
        return campos.find(item => item.campo === campo)?.texto || '';
    };

    return (
        <div className="mt-5 w-full max-w-2xl font-sans">
            <h3 className="text-xl font-medium text-gray-800 mb-1">
                Nombre de cada uno de los pastores con quienes ha estado trabajando
            </h3>
            <p className="text-sm text-gray-600 mb-4">
                Ingrese nombre y apellido de al menos un pastor:
            </p>
            <div className="space-y-2 mb-4">
                {pastores.map((item, index) => (
                    <div 
                        key={index} 
                        className="flex items-center justify-between p-3 bg-white border-l-4 border-blue-600 hover:bg-gray-50 transition-colors"
                    >
                        <div className="flex items-center space-x-4">
                            <div className="w-5 h-5 rounded-full border-2 border-gray-300 flex-shrink-0" />
                            <span className="text-gray-700 text-base">{item}</span>
                        </div>
                        
                        <IconButton 
                            size="small" 
                            onClick={() => deletePastor(index)}
                            className="text-gray-400 hover:text-red-500"
                        >
                            <CloseOutlinedIcon fontSize="small" />
                        </IconButton>
                    </div>
                ))}
            </div>

            <div className="mt-4">
                {(!agregarNombre && pastores.length > 0) && (
                    <Button 
                        startIcon={<PlusOneIcon />} 
                        variant="text" 
                        color="primary" 
                        onClick={agregarPastor}
                        className="normal-case font-medium"
                    >
                        Agregar otro pastor
                    </Button>
                )}
                {(agregarNombre || pastores.length === 0) && (
                    <InputPastor 
                        esPrimero={pastores.length === 0} 
                        addPastor={addPastor} 
                        finalizar={() => setAgregarNombre(false)} 
                    />
                )}
            </div>

            <FormHelperText className="Mui-error mt-2">
                {checkvalidacion('pastores', validacion)}
            </FormHelperText>
        </div>
    );
};

const InputPastor = ({ addPastor, finalizar, esPrimero }) => {
    const [nombre, setNombre] = useState('');

    const guardar = () => {
        if (nombre.length >= 10) {
            addPastor(nombre);
            finalizar();
        } else {
            alert('Agregue un nombre de al menos 10 caracteres');
        }
    };

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center mt-4 p-4 bg-blue-50 rounded-lg border border-blue-100">
            <TextField 
                label="Nombre y apellido del pastor" 
                variant="outlined"
                size="small"
                id="input-pastor-t"
                value={nombre} 
                onChange={(e) => setNombre(e.target.value)}
                className="bg-white"
                style={{ width: '300px' }}
            />
            
            <div className="flex space-x-2 mt-3 sm:mt-0 sm:ml-4">
                {nombre.length > 1 && (
                    <Button 
                        size="small" 
                        startIcon={<AddCircleIcon />} 
                        variant="contained" 
                        color="primary" 
                        onClick={guardar}
                        className="shadow-none"
                    >
                        Agregar
                    </Button>
                )}
                {!esPrimero && (
                    <Button 
                        size="small" 
                        variant="text" 
                        onClick={finalizar}
                        className="text-gray-500"
                    >
                        Cancelar
                    </Button>
                )}
            </div>
        </div>
    );
};